// extracted by mini-css-extract-plugin
export var list = "checklist-module--list--38blW";
export var listItem = "checklist-module--listItem--x2BKR";
export var listText = "checklist-module--listText--ymtJn";